import { lazy, Suspense } from 'react';

const ObjectTree = lazy(async () => import('object_tree/Provider'));

export const ObjectTreeWrapper = (props: ObjectTreeProps) => {
  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-0 h-full w-full">
        <Suspense fallback={<></>}>
          <ObjectTree {...props} />
        </Suspense>
      </div>
    </div>
  );
};
